module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point02/th_01-cf1c437dd2eb9e828c0d9ac02858ca6e.jpg";